module.exports = {"130772105":"沙沟镇","130772215":"宇宙营乡","130772401":"察北管理区黄山管理处","130772402":"察北管理区石门管理处","130772403":"察北管理区乌兰管理处","130772404":"察北管理区金沙管理处","130772405":"察北管理区白塔管理处"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130772.json
// module id = 198
// module chunks = 0